import { render, staticRenderFns } from "./Retase.vue?vue&type=template&id=04c629e4&scoped=true&"
import script from "./Retase.vue?vue&type=script&lang=js&"
export * from "./Retase.vue?vue&type=script&lang=js&"
import style0 from "./Retase.vue?vue&type=style&index=0&id=04c629e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c629e4",
  null
  
)

export default component.exports